<template>
  <div class="suggestions">
    <div class="list-suggestion">
        <el-row 
            v-for="(item, idx) in spellcheck_resp"
            :key="idx"
            :class="'item-suggestion ' + ((spellcheck_resp.length - 1 == idx) ? 'last-item' : '')">
            <div class="remove-word-label" v-if="item.type == 'grammar' && item.suggestion == ''">
                <el-col :span="22">
                    {{ $t('study_sets.remove_the_word') }}
                    <el-tooltip class="item" effect="dark" content="Click to remove the word." placement="top-start">
                        <span @click="$emit('remove_word', props, item, idx)" class="word-removed"> {{item.original}} </span>
                    </el-tooltip>
                </el-col>
            </div>
            <div class="remove-word-label" v-else-if="item.type == 'grammar' && item.original == ''">
                <el-col :span="22">
                    {{ $t('study_sets.add') }}
                    <el-tooltip class="item" effect="dark" content="Click to add the word." placement="top-start">
                        <span @click="$emit('add_word', props, item, idx)" class="recommend-word"> {{item.suggestion}} </span>
                    </el-tooltip>
                </el-col>
            </div>
            <div v-else>
                <el-col :span="9"><span class="incorect-word">{{item.original}}</span></el-col>
                <el-col :span="4"><i class="elsa-icon-arrow" /></el-col>
                <el-col :span="9">
                    <el-tooltip class="item" effect="dark" content="Click to replace the word." placement="top-start">
                        <span @click="$emit('replace_one', props, item, idx)" class="recommend-word">{{item.suggestion}}</span>
                    </el-tooltip>
                </el-col>
            </div>
            <el-col :span="2" class="remove-item" >
                <i @click="$emit('remove_item', props, idx)" class="el-icon-close" />
            </el-col>
        </el-row>
    </div>
    <div v-if="spellcheck_resp.length > 1" class="bottom-action">
        <el-button class="ignore" size="mini" type="text" @click="$emit('ignore_all', props)">{{ $t('study_sets.ignore_all') }}</el-button>
        <el-button class="replace" type="primary" size="mini" @click="$emit('replace_all', props)">{{ $t('study_sets.replace_all') }}</el-button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    props: {
        props: {
            type: Object
        },
        spellcheck_resp: {
            type: Array
        }
    },
    computed: {
    },
  }
</script>

<style lang="scss" scoped>
    .list-suggestion{
        .item-suggestion {
            padding: 10px 0px;
            font-weight: 600;
            border-bottom: 1px solid #e6e6e6;
            .incorect-word {
                text-decoration: line-through;
                text-decoration-color: #EB001B;
            }
            .recommend-word {
                color: #2DA771;
                cursor: pointer;
            }
            .remove-item {
                text-align: right;
                cursor: pointer;
                .el-icon-close {
                    font-weight: bold;
                    font-size: 16px;
                }
            }
            .elsa-icon-arrow {
                padding-top: 4px;
            }
            .remove-word-label {
                font-size: 16px;
                line-height: 21px;
                display: block;
                color: #8E8E93;
                .word-removed {
                    color: #EB001B;
                    cursor: pointer;
                }
            }
        }
        .last-item {
            border: none;
        }
    }
    .bottom-action {
        text-align: right;
        margin: 20px 0px 0px;
        span {
            font-weight: 600;
            font-size: 10px;
            line-height: 24px;
        }
        .ignore {
            color: #8E8E93;
        }
        .replace {
            color: #FFFFFF;
            background: #007EFF;
            border-radius: 4px;
        }
    }
    // .el-tooltip__popper {
    //     &.is-dark {
    //             color: #FFFFFF;
    //             background: #322F65 !important;
    //             box-shadow: 0px 24px 32px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
    //             border-radius: 4px;
    //         }
    // }
</style>
